import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    scrollToClass(className) {
      // Get the first element with the given class name
      let el = this.$el.querySelector(className);
      // Get the bounding rectangle so we can get the element position position
      let rect = el.getBoundingClientRect();
      // Scroll to the element (using x and y axis)
      window.scrollTo({
        top: rect.top - 64,
        behavior: 'smooth',
      });
    }
  }
});

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
